import ToastError from "../components/molecules/ToastError"
import { patchOrder } from "../service/OrderService"
import React from "react"
import toast from "react-hot-toast"
import { useMutation, useQueryClient } from "react-query"

export default function usePatchOrder() {
  const queryClient = useQueryClient()

  const {
    data: patchOrderResult,
    mutate,
    isLoading: isMutating
  } = useMutation(patchOrder, {
    mutationKey: "patch-order",
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries("query-orders")
    },
    onError: (error) => {
      console.error(error)
      toast.error((t) => <ToastError message={error.message} handlePictoClick={() => toast.dismiss(t.id)} />, {
        id: error.message
      })
    }
  })

  return { patchOrderResult, mutate, isMutating }
}
